export default __webpack_public_path__ + "static/media/mentos_video.5837ecf2.mp4";